import { render } from "./AdjustmentList.vue?vue&type=template&id=12d37a8b&ts=true"
import script from "./AdjustmentList.vue?vue&type=script&lang=ts"
export * from "./AdjustmentList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__